import { COLOR } from '../config/tokens'

// A product without a photo gets this, never a broken image: parchment with a quiet
// diagonal hatch and no text (build-guide §6).
export function PhotoPlaceholder() {
  return (
    <div
      className="absolute inset-0"
      style={{
        background:
          'repeating-linear-gradient(45deg, ' +
          COLOR.parchment +
          ' 0px, ' +
          COLOR.parchment +
          ' 14px, ' +
          COLOR.line +
          ' 14px, ' +
          COLOR.line +
          ' 28px)',
      }}
    />
  )
}
